import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import DashboardTitle from "../../layout/DashboardTitle";
import {
  Card,
  Checkbox,
  Col,
  Dropdown,
  Flex,
  Form,
  Menu,
  Row,
  message,
} from "antd";
import {
  ExclamationCircleFilled,
  WarningFilled,
  SearchOutlined,
  CloseOutlined,
  CheckOutlined,
  
} from "@ant-design/icons";
import {
  CustomTitle,
  CustomParagraph,
  CustomButton,
  CustomInput,
  CustomizeFilterCalendar,
} from "../../components";
import EmptyShipments from "./EmptyShipments";
import ShipmentCard from "./ShipmentCard";
import ShipmentDrawer from "./ShipmentDrawer";
import {
  getCompanyCouriersDDL,
  getTeamsDDL,
} from "../../common/utils/dropDown";
//images
import FilterIconBlack from "../../assets/images/filter-list-black.svg";
import FilterIconWhite from "../../assets/images/filter-list-white.svg";
import { useLocation } from "react-router-dom";
// import ShipmentDetailDrawer from './ShipmentDetailDrawer';
// import { GoogleMapsProvider } from '../../components/GoogleMapsProvider';
// import ShipmentForm from '../Modals/ShipmentForm';
// import ShareShipment from '../Modals/ShareShipment';

import CreateShipmentModal from "../Modals/CreateShipmentModal";
import { useSpin } from "../../components/SpinContext";
import {
  GetShipments,
  GetShipmentSummary,
  GetShipmentsByFilter,
  GetShipmentLinkCodes,
} from "../../api's/shipment";
import { useToken } from "../../common/helper";
import {
  filtersList,
  shipmentStatusDDL,
  healthStatusDDL,
  deliveryStatusDDL,
  archivedDDL
} from "../../common/static_data";
import BulkUploadModal from "../Modals/BulkUploadModal.jsx";
import { GoogleMapsProvider } from "../../components/GoogleMapsProvider";
import CustomPagination from "../../components/CustomPagination";
import CommonDrawer from "../../components/CommonDrawer";
import CreateShipmentDrawer from "./CreateShipmentDrawer";
import {
  fetchAllProducts,
  selectProductState,
} from "../../reudx-toolkit/slice/ProductSlice.js";
import AnimatedShipmentCard from "./partials/AnimatedShipmentCard.jsx";

const Shipments = () => {
  const navigate = useNavigate();
  const mainMenu = useSelector((state) => state.menu.items);
  // console.log({ mainMenu });
  const shipmentPermissions = mainMenu?.find(
    (items) => items?.name?.toLowerCase() == "shipment"
  );
  const allPermissions = shipmentPermissions?.permissions;
  // console.log('shipment permissions : ' , allPermissions)

  // useEffect(() => {
  //   if (!shipmentPermissions?.permissions?.is_view) {
  //     navigate(-1);
  //   }
  // }, [])

  const [form] = Form.useForm();
  const { token, removeToken, decodedUserToken } = useToken();
  const { showSpin, hideSpin } = useSpin();
  const dispatch = useDispatch();
  const [isSearchVisible, setIsSearchVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedShipmentID, setSelectedShipmentID] = useState(null); //added by nisha
  const [shipmentsData, setShipmentsData] = useState([]);
  const [summaryData, setSummaryData] = useState({});
  const location = useLocation();
  const [drawerStateFromHome, setDrawerStateFormHome] = useState(
    {
      dState: location?.state?.drawerState ? location?.state?.drawerState : "",
      shipmentId: location?.state?.shipmentId
        ? location?.state?.shipmentId
        : null,
    } || {}
  );
  //All states relative to filters
  const [filteredData, setFilteredData] = useState(shipmentsData);
  const [filtersDDL, setFilters] = useState(filtersList);
  const [secondaryFiltersDDL, setSecondaryFiltersDDL] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [secondFilterDisplay, setSecondFilterDisplay] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [filterTitle, setFilterTitle] = useState(
    "Select property to filter by"
  );
  const [filterArray, setFilterArray] = useState([]);
  const [filterBy, setFilterBy] = useState("");
  const [isDatePicker, setIsDatePicker] = useState(false);
  const [showAppliedFilters, setShowAppliedFilters] = useState(false);
  //store states
  const state = useSelector((state) => state);
  const [couriersList, setCouriersList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [productTypeList, setProductTypeList] = useState([]);
  const [productList, setProductList] = useState([]);
  const projectsID = useSelector(selectProductState);


  const [projectIdList, setProjectIdList] = useState([]);
  //bulk upload states
  const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
  const [startAlertsInterval, setStartAlertsInterval] = useState(true);
  const [search, setSearch] = useState("");
  let decodedToken = decodedUserToken();
  const [queryString, setQueryString] = useState({ query: null });

  // const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  // const pageSize = 10;

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);

  const [maxPageSize, setMaxPageSize] = useState();
  const totalItems = 100; // Example total items
  // const totalPages = Math.ceil(totalItems / pageSize);

  // teams for drop down
  const [allTeams, setAllTeams] = useState([]);
  const [shipmentLinkCodes, setShipmentLinkCodes] = useState([]);

  const getSettingsPermissions = (mainMenu) => {
    const settingsMenu = mainMenu?.find((menu) => menu?.name === "Settings");

    if (!settingsMenu || !settingsMenu.sub_menus) {
      return {};
    }

    const permissions = {
      locationsView: false,
      transportProvidersView: false,
      productsView: false,
    };

    settingsMenu.sub_menus.forEach((submenu) => {
      const name = submenu.name?.toLowerCase() || "";

      if (name.includes("location")) {
        permissions.locationsView = submenu.permissions?.is_view ?? false;
      }
      if (name.includes("transport provider")) {
        permissions.transportProvidersView =
          submenu.permissions?.is_view ?? false;
      }
      if (name.includes("product")) {
        permissions.productsView = submenu.permissions?.is_view ?? false;
      }
    });

    // console.log({ permissions });
    return permissions;
  };

  // Get Shipment Link Codes and teams
  useEffect(() => {
    getTeamsDDL(token).then((val) => {
      if (val && val.length > 0) {
        setAllTeams(val);
      }
    });

    GetShipmentLinkCodes(token).then((val) => {
      const data = val?.data?.data?.data?.link_codes;
      if (data?.length) {
        const formatted = data.map((item, index) => ({
          id: item,
          name: item,
        }));
        setShipmentLinkCodes(formatted);
      }
    });
  }, []);

  const handlePageSizeChange = (newPageSize) => {
    if (!newPageSize || newPageSize < 1) return; // Prevent null/invalid values
    if (newPageSize > 200) newPageSize = 200; // Enforce max limit

    setPageSize(newPageSize);
    setPage(1); // Reset to page 1 when page size changes
    fetchShipments(searchQuery, true, 1, newPageSize);
  };

  const handlePageChange = (newPage) => {
    setPage((prevPage) => {
      const validPage = newPage > 0 ? newPage : 1;
      fetchShipments(null, true, validPage, pageSize);
      return validPage;
    });
  };

  useEffect(() => {
    if (state) {
      if (
        state?.Locations?.locationList &&
        state?.Locations?.locationList.length > 0
      ) {
        setLocationList(state?.Locations?.locationList);
      }
      if (
        state?.ProductTypes?.productTypeList &&
        state?.ProductTypes?.productTypeList.length > 0
      ) {
        setProductTypeList(state?.ProductTypes?.productTypeList);
      }
      if (
        state?.Products?.productList &&
        state?.Products?.productList.length > 0
      ) {
        setProductList(state?.Products?.productList);
      }
    }
  }, [state]);

  useEffect(() => {
    getCompanyCouriersDDL(token).then((val) => {
      if (val && val.length > 0) {
        let arr = val.map((item) => {
          return { ...item, id: item.courier_id };
        });
        setCouriersList(arr);
      }
    });
  }, []);

  //setting project id dropdown for filters
  // useEffect(() => {
  //   if (shipmentsData && shipmentsData?.length > 0) {
  //     const arr = shipmentsData
  //       .filter((item) => item?.product?.project_id != null)
  //       .map((item) => ({
  //         id: item?.product?.project_id,
  //         name: item?.product?.project_id,
  //       }));
  //     setProjectIdList(arr); // Update state
  //   }
  // }, [shipmentsData]);

  useEffect(() => {
    if (dispatch) {
      dispatch(fetchAllProducts(token));
    }
  }, [dispatch]);

  useEffect(() => {
    if (projectsID?.productList?.length > 0) {
      const arr = projectsID.productList
        .filter(
          (item) =>
            item?.project_id !== null &&
            item?.project_id !== undefined &&
            item?.project_id !== ""
        )
        .map((item) => ({
          id: item.project_id,
          name: item.project_id,
        }));
      // console.log('arr', arr);
      setProjectIdList(arr);
    }
  }, [projectsID]);

  // console.log({ filtersDDL });

  //function to set secondary drop down value by primary dd values
  const handleFilterClick = (filter) => {
    setSelectedOptions([]);
    setSecondaryFiltersDDL([]);
    setIsDatePicker(false);
    setFilterTitle(`Filter by ${filter.label}`);
    setFilterBy(filter.key);
    setShowAppliedFilters(appliedFilters.length > 0);


    // to check if filter?.id is 14 (archived)

    if (filter?.id===14) {
      handleSecondaryFilterSelect({ target: { checked: true } }, {
        id: "ARCHIVED",
        name: "Archived"
      }); 
      
      setQueryString({query:`filterBy=${filter?.key}&filterValue[]=${filter?.key}`})
      setAppliedFilters((prevState) => {
        return [...prevState, {
          "id": filter?.key,
          "name": filter?.label
              }];
      });
      setShowAppliedFilters(true);

      handleApplyFilters()
      return;
    }

    if (filter.id == 11) {
      setSecondaryFiltersDDL(couriersList.length > 0 ? couriersList : []);
    } else if (filter.id == 1 || filter.id == 2) {
      setSecondaryFiltersDDL(locationList.length > 0 ? locationList : []);
    } else if (filter.id == 3) {
      setSecondaryFiltersDDL(shipmentStatusDDL);
    } else if (filter.id == 4) {
      setSecondaryFiltersDDL(healthStatusDDL);
    } else if (filter.id == 5) {
      setSecondaryFiltersDDL(deliveryStatusDDL);
    } else if (filter.id == 7) {
      setSecondaryFiltersDDL(productTypeList.length > 0 ? productTypeList : []);
    } else if (filter.id == 6) {
      setSecondaryFiltersDDL(productList.length > 0 ? productList : []);
    } else if (filter.id == 8) {
      setSecondaryFiltersDDL(projectIdList);
    } else if (filter.id == 9 || filter.id == 10) {
      setIsDatePicker(true);
    } else if (filter.id == 12) {
      setSecondaryFiltersDDL(allTeams);
    } else if (filter.id == 13) {
      setSecondaryFiltersDDL(shipmentLinkCodes);
    }
    else if (filter.id == 14) {
      setSecondaryFiltersDDL(archivedDDL);
    }
    setSecondFilterDisplay(true);
  };

  //setting all secondary dd selected values in selected options & applied filters
  const handleSecondaryFilterSelect = (e, option) => {
    if (e?.target?.checked) {
      //if  selected option already exists then return previous state , else update previous
      // setAppliedFilters((prevState) => {
      //   const alreadyExists = prevState.findIndex(
      //     (item) => item.id === option.id
      //   );
      //   if (alreadyExists == -1) {
      //     return [...prevState, option];
      //   }
      //   return prevState;
      // });
      setSelectedOptions((prevState) => {
        const alreadyExists = prevState.findIndex(
          (item) => item.id === option.id
        );
        if (alreadyExists == -1) {
          return [...prevState, option];
        }
        return prevState;
      });
    } else {
      //just removing the unslected value from selected options and applied filters
      setSelectedOptions((prevState) =>
        prevState.filter((selectedOption) => selectedOption.id !== option.id)
      );
      // setAppliedFilters((prevState) =>
      //   prevState.filter((selectedOption) => selectedOption.id !== option.id)
      // );
    }
  };

  //reset filters state
  const resetFilterState = () => {
    setSelectedOptions([]);
    setFilterBy("");
    setFilters(filtersList);
    setSecondFilterDisplay(false);
    setSecondaryFiltersDDL([]);
  };

  const filterByLinkCode = (linkCode) => {
    if (linkCode) {
      setFilterBy("link_code");

      let option = { id: linkCode, name: `Group: ${linkCode}` };
      let applyFilters = appliedFilters;
      applyFilters = applyFilters.filter(
        (selectedOption) => selectedOption.id !== linkCode
      );
      setAppliedFilters((prevState) => {
        const alreadyExists = prevState.findIndex(
          (item) => item.id === option.id
        );
        if (alreadyExists == -1) {
          return [...prevState, option];
        }
        return prevState;
      });

      setShowAppliedFilters(true);
      let model = {
        filterBy: "link_code",
        filterValue: [linkCode],
      };
      let updatedValue = updateFilterArrayState(model);
      let queryString = queryStringForFilter(updatedValue);
      setQueryString({ query: queryString });
    }
  };

  //apply filters other than scheduled pickup and delivered date
  const handleApplyFilters = () => {
    if (filterBy && selectedOptions?.length > 0) {
      if (filterBy === "link_code") {
        setAppliedFilters((prevState) => {
          const newOptions = selectedOptions
            .filter((opt) => !prevState.some((item) => item.id === opt.id))
            .map((opt) => ({
              ...opt,
              name: `Group: ${opt.name}`,
            }));

          return [...prevState, ...newOptions];
        });
      } else {
        setAppliedFilters((prevState) => {
          const newOptions = selectedOptions.filter(
            (opt) => !prevState.some((item) => item.id === opt.id)
          );
          return [...prevState, ...newOptions];
        });
      }

      setShowAppliedFilters(true);
      let arr = selectedOptions.map((x) => x.id);
      let model = {
        filterBy: filterBy,
        filterValue: arr,
      };
      // setShowAppliedFilters(appliedFilters.length > 0);
      let updatedValue = updateFilterArrayState(model);
      let queryString = queryStringForFilter(updatedValue);
      setPage(1);
      setFilteredData([]);
      if (queryString) {
        setQueryString({ query: queryString });
        //f//etchShipments(searchQuery,false,)
        // filtershipments(queryString);
      }
    }
  };
  // 3 tiles click filters
  const handleTilesFilters = (id, name) => {
    setFilterBy("type");
    let option = { id: id, name: name };
    //setAppliedFilters([{ id: id, name: name }]);
    setShowAppliedFilters(true);
    let model = {
      filterBy: "type",
      filterValue: [id],
    };
    let applyFilters = appliedFilters;
    applyFilters = applyFilters.filter(
      (selectedOption) => selectedOption.id !== id
    );
    setPage(1);
    setAppliedFilters((prevState) => {
      const alreadyExists = prevState.findIndex(
        (item) => item.id === option.id
      );
      if (alreadyExists == -1) {
        return [...prevState, option];
      }
      return prevState;
    });

    let updatedValue = updateFilterArrayState(model);
    let queryString = queryStringForFilter(updatedValue);

    //let queryString = `filterBy=${model.filterBy}&filterValue[]=${model.filterValue[0]}`;
    setQueryString({ query: queryString });
    // filtershipments(queryString);
    // fetchShipments(searchQuery,false)
  };
  //filter helper functions
  const queryStringForFilter = (data) => {
    let queryString = null;
    if (data && data.length > 0) {
      queryString = data
        .map((element) => {
          if (element && element.filterBy && element.filterValue) {
            let values = Array.isArray(element.filterValue)
              ? element.filterValue.join(",")
              : element.filterValue;
            return `filterBy=${element.filterBy}&filterValue[]=${values}`;
          }
          return "";
        })
        .filter(Boolean) // Remove any empty strings
        .join("&");
    }
    return queryString;
  };
  const updateFilterArrayState = (model) => {
    let prev = filterArray ? [...filterArray] : [];
    let existingIndex = prev.findIndex(
      (item) => item?.filterBy === model.filterBy
    );
    if (existingIndex !== -1) {
      let existingValues = prev[existingIndex].filterValue || [];
      let newValues = Array.isArray(model.filterValue)
        ? model.filterValue
        : [model.filterValue];
      prev[existingIndex].filterValue = Array.from(
        new Set([...existingValues, ...newValues])
      );
      // /prev[existingIndex].filterValue = newValues;
    } else {
      prev = [...prev, model];
    }
    setFilterArray(prev);
    return prev;
  };

  //remove filter
  const removeAppliedFilter = (filter) => {
    let arr = [];
    let ind = -1;
    let i = -1;
    if (filterArray.length > 0) {
      if (filter?.dateFilter) {
        let filterIteration = filterArray.find(
          (x) => x.filterBy === filter.dateFilter
        );
        i = filterArray.findIndex((x) => x.filterBy === filter.dateFilter);
        if (i > -1) {
          ind = i;
          arr = filterIteration.filterValue.filter((x) => x !== filter.id);
        }
      } else {
        filterArray.forEach((element, index) => {
          if (
            element &&
            element.filterValue &&
            Array.isArray(element.filterValue)
          ) {
            i = element.filterValue.findIndex((x) => x == filter.id);

            if (i > -1) {
              ind = index;
              arr = element.filterValue.filter((x) => x !== filter.id);
            }
          }
        });
      }
    }
    let prevs = [...filterArray];
    if (ind > -1) {
      prevs[ind].filterValue = arr;
    }
    prevs = prevs.filter((u) => u.filterValue.length !== 0);
    setFilterArray(prevs);
    let applyFilters = [...appliedFilters]; // use `let` instead of `const`

    if (filter.dateFilter) {
      applyFilters = applyFilters.filter(
        (selectedOption) => selectedOption.dateFilter !== filter.dateFilter
      );

      const x = appliedFilters.filter(
        (x) => x.dateFilter === filter.dateFilter && x.id !== filter.id
      );

      applyFilters = [...applyFilters, ...x];
    } else {
      applyFilters = applyFilters.filter(
        (selectedOption) => selectedOption.id !== filter.id
      );
    }

    if (applyFilters.length == 0) {
      setAppliedFilters([]);
      setFilterArray([]);
      resetFilterState([]);
      setQueryString({ query: null });
      //fetchShipments(searchQuery, true);
      return;
    }
    setAppliedFilters(applyFilters);
    // setAppliedFilters((prevState) =>
    //   prevState.filter((selectedOption) => selectedOption.id !== filter.id)
    // );
    let queryString = queryStringForFilter(prevs);
    setQueryString({ query: null });
    if (queryString) {
      setQueryString({ query: queryString });
      //fetchShipments(searchQuery,false)
      //filtershipments(queryString,true,)
    }
  };

  //shipment fror filter
  const filtershipments = (model, check) => {
    if (check) {
      showSpin();
    }
    GetShipmentsByFilter(token, model)
      .then((res) => {
        const data = res?.data ? res.data : null;
        if (data) {
          if (data?.data?.is_success) {
            let resp = data?.data?.data ? data?.data?.data : [];
            if (resp) {
              setFilteredData(resp);
              resetFilterState();
            }
          } else {
            //message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  const handleSearchIconClick = () => {
    setIsSearchVisible(true);
  };

  //Apply filters for scheduled delivery and pickup date
  const handleDataFromChild = (value) => {
    if (value) {
      let model = {
        filterBy: filterBy,
        filterValue: [
          JSON.stringify({ start: value.rangeStart, end: value.rangeEnd }),
        ],
      };

      let updatedValue = updateFilterArrayState(model);
      let queryString = queryStringForFilter(updatedValue);

      let filtername =
        filterBy === "scheduled_pickup_date"
          ? "Scheduled pickup:"
          : "Scheduled delivery:";
      const filterString = `${filtername}${
        value?.rangeStart && value?.rangeEnd
          ? ` ${value.rangeStart} - ${value?.rangeEnd}`
          : value?.rangeStart
          ? ` ${value?.rangeStart}`
          : value?.rangeEnd
          ? ` ${value?.rangeEnd}`
          : ""
      }`;
      let applyFilters = appliedFilters ? [...appliedFilters] : [];
      const newId = JSON.stringify({
        start: value.rangeStart,
        end: value.rangeEnd,
      });
      const alreadyExists = applyFilters.some(
        (item) => item.id === newId && item.filterBy === filterBy
      );
      if (!alreadyExists) {
        applyFilters.push({
          id: newId,
          name: filterString,
          dateFilter: filterBy,
        });
      }

      setAppliedFilters(applyFilters);
      setShowAppliedFilters(applyFilters.length > 0);
      setFilteredData([]);
      setQueryString({ query: null });
      if (queryString) {
        setQueryString({ query: queryString });
        //filtershipments(queryString);
        // fetchShipments(searchQuery, false);
      }
    }
  };

  const handleSearch = (e) => {
    // const newQuery = e.target.value;
    // setSearchQuery(newQuery);

    // Use the latest value from `newQuery`, NOT `searchQuery`
    if (searchQuery.trim() !== "") {
      fetchShipments(searchQuery, true);
    } else {
      fetchShipments("", true);
    }
  };

  useEffect(() => {
    if (
      drawerStateFromHome &&
      drawerStateFromHome?.dState == "open" &&
      drawerStateFromHome?.shipmentId
    ) {
      toggleDrawer(
        drawerStateFromHome.dState,
        "Detail",
        drawerStateFromHome?.shipmentId
      );
    }
  }, [drawerStateFromHome]);

  const handleCloseSearch = () => {
    setIsSearchVisible(false);
    setSearchQuery("");
    fetchShipments("", true);

    setFilteredData(shipmentsData);
  };

  useEffect(() => {
    fetchShipments(searchQuery, false);
  }, [queryString]);

  const [shipmentFormModalOpen, setShipmentFormModalOpen] = useState(false);
  const [openCreateShipmentDrawer, setOpenCreateShipmentDrawer] =
    useState(false);

  const setCreateShipmentClose = () => {
    //Added by nisha (for cancel)
    setShipmentFormModalOpen(false);
  };

  const shipmentSuccess = () => {
    //Added by nisha (for success with fetch call)
    setShipmentFormModalOpen(false);
    fetchShipments(searchQuery, true);
    fetchShipmentSummary(true);
    //call get shipment call here
  };

  const [drawerState, setDrawerState] = useState({
    isOpen: false,
    name: "",
    shipmentId: null,
  });

  useEffect(() => {
  if (drawerState.open && drawerState?.name==='notifications') {
    document.documentElement.classList.add("hide-scrollbar");
  } else {
    document.documentElement.classList.remove("hide-scrollbar");
  }
}, [drawerState.open]);

  const toggleDrawer = (state, name, shipmentId) => {
    setDrawerState({
      isOpen: state === "open",
      name,
      shipmentId,
    });
    setSelectedShipmentID(shipmentId); //added by nisha
  };

  // const handleCheckboxChange = (filterKey, checkedValues) => {
  //   setSelectedFilterValue({
  //     ...selectedFilterValue,
  //     [filterKey]: checkedValues,
  //   });
  // };

  const handleShipmentFormModal = () => {
    // setShipmentFormModalOpen(true);
    setOpenCreateShipmentDrawer(true);
  };

  const handleConnectButtonClick = () => {
    navigate("/settings/couriers");
  };

  const handleTrackButtonClick = () => {};

  //Calls to run every time when component loads , for summary and shipment listing
  useEffect(() => {
    setAppliedFilters([]);
    setFilterArray([]);
    fetchShipments(searchQuery, true);
    fetchShipmentSummary(true);
  }, []);

  useEffect(() => {
    const fetchShipmentAlertData = () => {
      fetchShipments(searchQuery, false, page, pageSize);
      fetchShipmentSummary(false);
    };

   const intervalId = setInterval(() => {
      fetchShipmentAlertData();
   }, 30000);
   return () => clearInterval(intervalId);
  }, [startAlertsInterval, searchQuery, queryString, page, pageSize]);

  const newShipmentIdsRef = useRef([]);
  const [newShipmentData, setNewShipmentData] = useState([]);

  const onCreateShipmentSuccess = (data) => {
    setNewShipmentData((prev) => [...prev, data]);
    newShipmentIdsRef.current.push(data.id);
    // fetchShipments(); // safe to use
  };
  const onEditShipmentSuccess = (data) => {
    setNewShipmentData((prev) => {
      const index = prev.findIndex(item => item.id === data.id);
      if (index !== -1) {
        // Replace existing object
        const updated = [...prev];
        updated[index] = data;
        return updated;
      }
       else {
        // Add new object
        return [...prev];
        // return [...prev, data];
      }
    });
    
    fetchShipments(searchQuery, false, page, pageSize);
  };

  const fetchShipmentSummary = (check) => {
    if (check) {
      //showSpin();
    }
    GetShipmentSummary(token)
      .then((res) => {
        const data = res?.data ? res.data : null;
        if (data) {
          if (data?.data?.is_success) {
            let resp = data?.data?.data ? data?.data?.data : [];
            if (resp) {
              setSummaryData(resp);
            }
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        //hideSpin();
      });
  };

  const fetchShipments = (searchquery, check, page = 1, pageSize = 50) => {
    let q = null;
    if (queryString.query) {
      q = queryString.query;
    }
    if (queryString.query && searchquery) {
      q = queryString.query + "&search=" + encodeURIComponent(searchquery);
    }
    if (check) {
      showSpin();
    }

    const params =
      q !== null ? q : searchquery ? { search: searchquery?.toLowerCase() } : {};
    const paramsString = new URLSearchParams(params).toString();
    let parametersToSend = paramsString
      ? `${paramsString}&page=${page}&page_size=${pageSize}`
      : `page=${page}&page_size=${pageSize}`;
    GetShipments(token, parametersToSend)
      .then((res) => {
        const data = res?.data ? res.data : null;
        if (data) {
          if (data?.data?.is_success) {
            setMaxPageSize(data?.data?.shipment_count);
            setTotalPages(data?.data?.page_count);
            const resp = data?.data?.data ? data.data.data : [];
            setFilteredData([]);
            // setShipmentsData([]);

            if (resp.length > 0) {
              const newIds = newShipmentIdsRef.current;
              const filteredResp = resp.filter(
                (item) => !newIds.includes(item.id)
              );
              setFilteredData(filteredResp);
              setShipmentsData(resp.length===1 ? resp : filteredResp);

              // setShipmentsData(resp);
              // setFilteredData(resp);
            } else {
              setFilteredData([]);
            }
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  // First, get permissions
  const permissions = getSettingsPermissions(mainMenu);
  // console.log("sadsadsad", { permissions });
  // const permissions = {
  //   locationsView: false,
  //   productsView: false,
  //   transportProvidersView: false,
  // };

  // console.log({permissions})
  // Then, build your menu
  const menu = (
    <Menu
      style={{
        width: "250px",
        borderRadius: "12px",
        boxShadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.27)",
        marginTop: "5px",
        paddingTop: "8px",
        paddingBottom: "8px",
      }}
    >
      <Menu.ItemGroup
        title={
          <CustomParagraph
            text={filterTitle}
            fontSize={12}
            fontWeight={500}
            lineHeight="16px"
            color="#000"
            marginBottom={0}
          />
        }
      >
        {filtersDDL.map((filter) => {
          let isDisabled = false;

          if (
            (filter.key === "from_location" || filter.key === "to_location") &&
            permissions.locationsView === false
          ) {
            isDisabled = true;
          }
          if (
            filter.key === "courier" &&
            permissions.transportProvidersView === false
          ) {
            isDisabled = true;
          }
          if (
            (filter.key === "product" ||
              filter.key === "product_type" ||
              filter.key === "project_id") &&
            permissions.productsView === false
          ) {
            isDisabled = true;
          }

          return (
            <Menu.Item
              key={filter.id}
              onClick={() => !isDisabled && handleFilterClick(filter)}
              disabled={isDisabled}
              style={{ padding: "4px 10px" }}
            >
              <CustomParagraph
                text={filter.label}
                fontSize={12}
                fontWeight={400}
                lineHeight="20px"
                color={isDisabled ? "#B0B0B0" : "#000"} // << Grey if disabled
                marginBottom={0}
              />
            </Menu.Item>
          );
        })}
      </Menu.ItemGroup>
    </Menu>
  );

  const calendarMenu = () => {
    return (
      <Menu
        style={{
          width: "auto",
          borderRadius: "12px",
          boxShadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.27)",
          top: "5px",
          paddingTop: "8px",
          paddingBottom: "8px",
        }}
      >
        <Menu.ItemGroup
          title={
            <CustomParagraph
              text={filterTitle}
              fontSize={12}
              fontWeight={500}
              lineHeight="16px"
              color={"#000"}
              marginBottom={0}
            />
          }
        >
          <CustomizeFilterCalendar
            handleDataFromChild={handleDataFromChild}
          ></CustomizeFilterCalendar>
        </Menu.ItemGroup>
      </Menu>
    );
  };

  // const renderSubMenu = () => {
  //   return (
  //     <Menu
  //       style={{
  //         width: "250px",
  //         borderRadius: "12px",
  //         boxShadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.27)",
  //         top: "5px",
  //         paddingTop: "8px",
  //         paddingBottom: "8px",
  //       }}
  //     >
  //       <Menu.ItemGroup
  //         title={
  //           <CustomParagraph
  //             text={filterTitle}
  //             fontSize={12}
  //             fontWeight={500}
  //             lineHeight="16px"
  //             color={"#000"}
  //             marginBottom={0}
  //           />
  //         }
  //       >
  //         {secondaryFiltersDDL.map((option) => (
  //           <Menu.Item key={option.id}>
  //             <Checkbox
  //               key={option.id}
  //               onChange={(e) => handleSecondaryFilterSelect(e, option)}
  //             >
  //               {option?.title || option?.name || option?.courier_name}
  //             </Checkbox>
  //           </Menu.Item>
  //         ))}
  //       </Menu.ItemGroup>
  //       <Flex style={{ padding: "8px 4px 0" }} justify="flex-end">
  //         <CustomButton
  //           text="Apply"
  //           onClick={handleApplyFilters}
  //           width={62}
  //           height={36}
  //           bgColor="#000"
  //           color="#fff"
  //           fontSize={14}
  //           fontWeight={500}
  //           borderRadius={8}
  //           boxShadow="0px 4px 16px 0px rgba(0, 0, 0, 0.27)"
  //         />
  //       </Flex>
  //     </Menu>
  //   );
  // };

  //bulk upload functionality

  const renderSubMenu = () => {
    return (
      <Menu
        style={{
          width: "250px",
          borderRadius: "12px",
          boxShadow: "0px 4px 16px 0px rgba(0, 0, 0, 0.27)",
          top: "5px",
          paddingTop: "8px",
          paddingBottom: "8px",
        }}
      >
        <div
          style={{
            maxHeight: "500px",
            overflowY: "auto",
            paddingBottom: "8px",
          }}
        >
          <Menu.ItemGroup
            title={
              <CustomParagraph
                text={filterTitle}
                fontSize={12}
                fontWeight={500}
                lineHeight="16px"
                color={"#000"}
                marginBottom={0}
              />
            }
          >
            {secondaryFiltersDDL.map((option) => (
              <Menu.Item key={option.id} style={{ padding: "4px 10px" }}>
                <Checkbox
                  style={{ fontSize: "12px" }}
                  className="custom-menu-shipment-checkbox"
                  key={option.id}
                  disabled={
                    appliedFilters.findIndex((x) => x.id === option.id) > -1
                  }
                  //checked={appliedFilters.findIndex(x=>x.id === option.id) > -1}
                  onChange={(e) => handleSecondaryFilterSelect(e, option)}
                >
                  {option?.title || option?.name || option?.courier_name}
                </Checkbox>
              </Menu.Item>
            ))}
          </Menu.ItemGroup>
        </div>
        <Flex
          style={{
            position: "sticky",
            bottom: "0",
            padding: "8px 4px 0",
          }}
          justify="flex-end"
        >
          <CustomButton
            text="Apply"
            onClick={handleApplyFilters}
            width={62}
            height={32}
            bgColor="#000"
            color="#fff"
            fontSize={12}
            fontWeight={500}
            borderRadius={8}
            boxShadow="0px 4px 16px 0px rgba(0, 0, 0, 0.27)"
          />
        </Flex>
      </Menu>
    );
  };

  const handleBulkUpload = () => {
    setShowBulkUploadModal(true);
  };

  const handleCloseDrawer = () => {
    setOpenCreateShipmentDrawer(false);
    fetchShipments(searchQuery, true);
    form.resetFields();
  };

  return (
    <>
      <div
        className={`shipment-section ${drawerState.isOpen && "open"} `}
        style={{ paddingBottom: "40px" }}
      >
        <DashboardTitle
          title="Shipments"
          showAddButton={true}
          addButtonTitle={"New Shipment"}
          onAddButtonClick={handleShipmentFormModal}
          onBulkUpload={handleBulkUpload}
          allPermissions={allPermissions}
        />
        {shipmentsData.length === 0 && (
          <EmptyShipments
            handleConnectButtonClick={handleConnectButtonClick}
            handleShipmentFormModal={handleShipmentFormModal}
            userRole={decodedToken?.role}
            allPermissions={allPermissions}
          />
        )}
        {/* {shipmentsData.length === 0 && (
          <Flex justify="center" align="flex-start">
            <Flex
              gap={12}
              vertical={true}
              style={{
                maxWidth: "556px",
                textAlign: "center",
                paddingTop: "40px",
              }}
            >
              <div
                className="empty-shipment-icon"
                style={{ position: "relative", height: "228px" }}
              >
                <div
                  className="bg"
                  style={{
                    backgroundImage: `url(${EmptyShipmentBg})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    textAlign: "center",
                    width: "324px",
                    height: "inherit",
                    margin: "0 auto",
                    position: "relative",
                    backgroundSize: "contain",
                  }}
                >
                  <img
                    src={EmptyShipmentBox}
                    alt=""
                    style={{ position: "relative", bottom: "30px" }}
                  />

                  <Flex
                    align="center"
                    justify="center"
                    style={{
                      width: "64px",
                      height: "64px",
                      borderRadius: "50%",
                      backgroundColor: "#fff",
                      position: "absolute",
                      bottom: "33px",
                      right: "30px",
                      cursor: "pointer",
                    }}
                  >
                    <PlusCircleFilled
                      style={{ fontSize: "32px", color: "#266EF1" }}
                    />
                  </Flex>
                </div>
              </div>

              <CustomTitle
                text={"You're not tracking any shipments yet"}
                fontSize={28}
                fontWeight={700}
                lineHeight={"36px"}
                color={"#000"}
                marginBottom={0}
              />

              <CustomTitle
                text={
                  "To start tracking your shipments, connect your transport providers, or manually enter your shipment tracking IDs."
                }
                fontSize={16}
                fontWeight={400}
                lineHeight={"24px"}
                color={"#000"}
                marginBottom={0}
                marginTop={0}
              />
              {decodedToken?.role?.toLowerCase() !== "viewer" &&

                <Flex wrap gap={8} align="center" justify="center">
                  <CustomButton
                    onClick={handleConnectButtonClick}
                    height="48px"
                    minWidth="204px"
                    fontSize="16px"
                    text={"Connect providers"}
                    bgColor="#F3F3F3"
                    borderRadius="40px"
                    color="#000"
                    boxShadow="none"
                    iconPosition="left"
                    image={LinkIcon}
                    gap="10px"
                    lineHeight={"20px"}
                    fontWeight={600}
                  />

                  <CustomButton
                    onClick={handleShipmentFormModal}
                    height="48px"
                    minWidth="178px"
                    fontSize="16px"
                    text={"Track manually"}
                    bgColor="#F3F3F3"
                    borderRadius="40px"
                    color="#000"
                    boxShadow="none"
                    iconPosition="left"
                    icon={<PlusOutlined />}
                    gap="10px"
                    lineHeight={"20px"}
                    fontWeight={600}
                  />

                </Flex>
              }
            </Flex>
          </Flex>
        )} */}

        {shipmentsData.length > 0 && (
          <>
            <Flex>
              <div style={{ flex: 1 }}>
                <Row gutter={[24, 16]} style={{ marginBottom: "20px" }}>
                  <Col
                    xxl={drawerState.isOpen ? 8 : 5}
                    xl={drawerState.isOpen ? 8 : 5}
                    lg={drawerState.isOpen ? 16 : 5}
                    md={drawerState.isOpen ? 24 : 12}
                    sm={drawerState.isOpen ? 24 : 12}
                    xs={24}
                    style={{
                      transition: "all 0.3s ease", // Smooth transition for width and other properties
                    }}
                  >
                    <Card
                      onClick={() => {
                        handleTilesFilters("0", "Critical alert");
                      }}
                      style={{
                        borderRadius: "8px",
                        background: "#f5f5f5",
                        cursor: "pointer",
                      }}
                      bodyStyle={{
                        padding: "15px", // Add padding here
                      }}
                    >
                      <Flex justify="space-between" align="center">
                        <div>
                          <CustomTitle
                            text={summaryData?.is_critical}
                            color="#000"
                            fontSize="18px"
                            lineHeight="24px"
                            fontWeight="700"
                            marginBottom={0}
                          />
                          <CustomParagraph
                            text={"Critical Alerts"}
                            color="#000"
                            fontSize="12px"
                            fontWeight="400"
                            lineHeight="20px"
                            marginBottom={0}
                          />
                        </div>

                        <Flex>
                          <Flex
                            align="center"
                            justify="center"
                            style={{
                              backgroundColor: "#DE1135",
                              borderRadius: "50%",
                              width: "36px",
                              height: "36px",
                            }}
                          >
                            <span style={{ fontSize: "16px", color: "white" }}>
                              <ExclamationCircleFilled />
                            </span>
                          </Flex>
                        </Flex>
                      </Flex>
                    </Card>
                  </Col>
                  <Col
                    xxl={drawerState.isOpen ? 8 : 5}
                    xl={drawerState.isOpen ? 8 : 5}
                    lg={drawerState.isOpen ? 16 : 5}
                    md={drawerState.isOpen ? 24 : 12}
                    sm={drawerState.isOpen ? 24 : 12}
                    xs={24}
                    style={{
                      transition: "all 0.3s ease", // Smooth transition for width and other properties
                    }}
                  >
                    <Card
                      onClick={() => {
                        handleTilesFilters("1", "At risk");
                      }}
                      style={{
                        borderRadius: "8px",
                        background: "#f5f5f5",
                        cursor: "pointer",
                      }}
                      bodyStyle={{
                        padding: "15px", // Add padding here
                      }}
                    >
                      <Flex justify="space-between" align="center">
                        <div>
                          <CustomTitle
                            text={summaryData?.is_risk}
                            color="#000"
                            fontSize="18px"
                            lineHeight="24px"
                            fontWeight="700"
                            marginBottom={0}
                          />
                          <CustomParagraph
                            text={"At risk"}
                            color="#000"
                            fontSize="12px"
                            fontWeight="400"
                            lineHeight="20px"
                            marginBottom={0}
                          />
                        </div>

                        <Flex>
                          <Flex
                            align="center"
                            justify="center"
                            style={{
                              backgroundColor: "#F6BC2F",
                              borderRadius: "50%",
                              width: "36px",
                              height: "36px",
                            }}
                          >
                            <span style={{ fontSize: "16px", color: "white" }}>
                              <WarningFilled />
                            </span>
                          </Flex>
                        </Flex>
                      </Flex>
                    </Card>
                  </Col>

                  <Col
                    xxl={drawerState.isOpen ? 8 : 5}
                    xl={drawerState.isOpen ? 8 : 5}
                    lg={drawerState.isOpen ? 16 : 5}
                    md={drawerState.isOpen ? 24 : 12}
                    sm={drawerState.isOpen ? 24 : 12}
                    xs={24}
                    style={{
                      transition: "all 0.3s ease", // Smooth transition for width and other properties
                    }}
                  >
                    <Card
                      onClick={() => {
                        handleTilesFilters("2", "No issue");
                      }}
                      style={{
                        borderRadius: "8px",
                        background: "#f5f5f5",
                        cursor: "pointer",
                      }}
                      bodyStyle={{
                        padding: "15px", // Add padding here
                      }}
                    >
                      <Flex justify="space-between" align="center">
                        <div>
                          <CustomTitle
                            text={summaryData?.is_track}
                            color="#000"
                            fontSize="18px"
                            lineHeight="24px"
                            fontWeight="700"
                            marginBottom={0}
                          />

                          <CustomParagraph
                            text={"No issue"}
                            color="#000"
                            fontSize="12px"
                            fontWeight="400"
                            lineHeight="20px"
                            marginBottom={0}
                          />
                        </div>

                        <Flex>
                          <Flex
                            align="center"
                            justify="center"
                            style={{
                              backgroundColor: "#0E8345",
                              borderRadius: "50%",
                              width: "36px",
                              height: "36px",
                            }}
                          >
                            <span style={{ fontSize: "12px", color: "white" }}>
                              {/* <CheckCircleFilled /> */}
                              <CheckOutlined />
                            </span>
                          </Flex>
                        </Flex>
                      </Flex>
                    </Card>
                  </Col>

                  {/* <Col span={5} xxl={5} xl={6} lg={8} md={12} sm={12} xs={24}>
                      <Card
                        style={{
                          height: "100px",
                          borderRadius: "8px",
                          background: "#f5f5f5",
                        }}
                      >
                        <Flex justify="space-between" align="center">
                          <div>
                            <CustomTitle text={summaryData?.total_shipments} color="#000" fontSize="24px" lineHeight="28px" fontWeight="700" marginBottom={0} />

                            <CustomParagraph text={"Total Shipments"} color="#000" fontSize="14px" fontWeight="400" lineHeight="28px" marginBottom={0} />
                          </div>

                          <Flex>
                            <Flex align="center" justify="center" style={{ backgroundColor: "#0E8345", borderRadius: "50%", width: "36px", height: "36px" }}>
                              <span style={{ fontSize: "16px", color: "#fff" }}><CalculatorOutlined /></span>
                            </Flex>
                          </Flex>
                        </Flex>
                      </Card>
                    </Col> */}
                </Row>

                <Row gutter={16} style={{ marginBottom: "16px" }}>
                  <Col span={24}>
                    <Flex
                      wrap
                      justify="space-between"
                      align="center"
                      gap="16px"
                    >
                      <Flex wrap gap="8px" align="center">
                        {isSearchVisible ? (
                          <Flex
                            className="search-filter"
                            align="center"
                            gap={8}
                          >
                            <CustomInput
                              value={searchQuery}
                              onChange={(e) => {
                                setSearchQuery(e.target.value);
                                if (e.target.value.trim() === "") {
                                  fetchShipments();
                                }
                              }}
                              placeholder="Search..."
                              boxShadow="none"
                              border="none"
                              height="28px"
                              borderRadius={'40px'}
                              style={{
                                width: "100%",
                                height: "28px",
                                fontSize:'12px',
                                borderRadius: "40px",
                              }}
                            />

                            <CustomButton
                              text="Search"
                              onClick={handleSearch}
                              bgColor="#000"
                              color="#fff"
                              fontSize={'10px'}
                              fontWeight={'600'}
                              height="28px"
                              borderRadius="40px"
                            />
                            <CustomButton
                              text="Close"
                              onClick={handleCloseSearch}
                              bgColor="#000"
                              color="#fff"
                              fontSize={'10px'}
                              fontWeight={'600'}
                              height="28px"
                              borderRadius="40px"
                            />
                          </Flex>
                        ) : (
                          <Flex
                            align="center"
                            justify="center"
                            style={{
                              width: "28px",
                              height: "28px",
                              borderRadius: "50%",
                              backgroundColor: "#F5F5F5",
                              cursor: "pointer",
                            }}
                            onClick={handleSearchIconClick}
                          >
                            <SearchOutlined style={{ fontSize: "12px" }} />
                          </Flex>
                        )}

                        <div className="custom-filter-dropdown">
                          <Dropdown
                            overlay={menu}
                            trigger={["click"]}
                            onVisibleChange={(visible) => console.log(visible)}
                          >
                            <Flex
                              justify="center"
                              align="center"
                              gap={6}
                              style={{
                                height: "28px",
                                width: "fit-content",
                                minWidth: "80px",
                                cursor: "pointer",
                                padding: "0 8px",
                                fontSize: "10px",
                                fontWeight: "600",
                                backgroundColor:
                                  appliedFilters.length > 0
                                    ? "#000"
                                    : "#F5F5F5",
                                color:
                                  appliedFilters.length > 0 ? "#FFF" : "#000",
                                borderRadius: "40px",
                              }}
                            >
                              <img
                                style={{ height: "12px" }}
                                src={
                                  appliedFilters.length > 0
                                    ? FilterIconWhite
                                    : FilterIconBlack
                                }
                                alt=""
                              />
                              Add filter
                            </Flex>
                          </Dropdown>

                          {secondFilterDisplay && (
                            <Dropdown
                              overlay={
                                isDatePicker ? calendarMenu() : renderSubMenu()
                              }
                              open={secondFilterDisplay}
                              trigger={["click"]}
                              onVisibleChange={(visible) =>
                                setSecondFilterDisplay(visible)
                              }
                            >
                              <div />
                            </Dropdown>
                          )}
                        </div>

                        <Flex gap={8} align="center">
                          <div className="filters pills flex  gap-x-2">
                            {showAppliedFilters &&
                              appliedFilters.map((filter, index) => (
                                <Flex
                                  key={index}
                                  gap={8}
                                  align="center"
                                  style={{
                                    height: "27px",
                                    padding: "0 12px",
                                    backgroundColor: "#000000",
                                    fontSize: "10px",
                                    fontWeight: "600",
                                    color: "#fff",
                                    borderRadius: "40px",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {filter?.name ||
                                    filter?.title ||
                                    filter?.courier_name}
                                  <CloseOutlined
                                    style={{ color: "#fff" }}
                                    onClick={() => removeAppliedFilter(filter)}
                                  />
                                </Flex>
                              ))}
                          </div>
                        </Flex>
                      </Flex>
                      <CustomParagraph
                        text={`${filteredData.length} shipments`}
                        fontSize="12px"
                        fontWeight="400"
                        lineHeight="20px"
                        marginBottom={0}
                        whiteSpace={"nowrap"}
                      />
                    </Flex>
                  </Col>
                </Row>
                {/* for animation  */}

                <Flex vertical>
                  {newShipmentData.map((card, index) => (
                    <AnimatedShipmentCard
                      key={card.id}
                      card={card}
                      toggleDrawer={toggleDrawer}
                      drawerState={drawerState}
                      openShipmentId={drawerState.shipmentId}
                      onExpire={(id) => {
                       setNewShipmentData((prev) => prev.filter((c) => c.id !== id));
                        newShipmentIdsRef.current = newShipmentIdsRef.current.filter((currId) => currId !== id);
                       fetchShipments(searchQuery,true,page,pageSize)
                      }}
                    />
                  ))}
                </Flex>

                {filteredData.length > 0 && (
                  <Row gutter={16} style={{ marginBottom: "16px" }}>
                    <Col span={24}>
                      <Flex vertical={true} gap={16}>
                        {filteredData.map((card, index) => (
                          <ShipmentCard
                            key={index}
                            card={card}
                            toggleDrawer={toggleDrawer}
                            drawerState={drawerState}
                            openShipmentId={drawerState.shipmentId}
                          />
                        ))}
                      </Flex>
                    </Col>
                  </Row>
                )}
                {filteredData.length == 0 && (
                  <Flex
                    align="center"
                    justify="center"
                    style={{ height: "50vh" }}
                  >
                    <CustomParagraph text={"No data available"} />
                  </Flex>
                )}
              </div>

              {/* <GoogleMapsProvider>
                  <ShipmentDetailDrawer
                    isOpen={drawerState.isOpen}
                    shipmentId={drawerState.shipmentId}
                    toggleDrawer={toggleDrawer}
                  />
                </GoogleMapsProvider> */}
              <ShipmentDrawer
                token={token}
                isOpen={drawerState.isOpen}
                name={drawerState.name}
                shipmentId={drawerState.shipmentId}
                toggleDrawer={toggleDrawer}
                shipmentSuccess={shipmentSuccess}
                filterByLinkCode={filterByLinkCode}
                onEditShipmentSuccess={onEditShipmentSuccess}
                // editNewShipment={onCreateShipmentSuccess}
              />
            </Flex>
          </>
        )}

        {filteredData.length > 0 && (
          <Row style={{ width: "100%", marginTop: "12px" }}>
            <Col flex="auto">
              <Flex justify="flex-end">
                <CustomPagination
                  maxPageSize={maxPageSize}
                  page={page}
                  totalPages={totalPages}
                  pageSize={50}
                  onPageChange={handlePageChange}
                  onPageSizeChange={handlePageSizeChange}
                />
              </Flex>
            </Col>
          </Row>
        )}

        {/* Added by nisha */}
        {shipmentFormModalOpen && (
          <GoogleMapsProvider>
            <CreateShipmentModal
              modalOpen={shipmentFormModalOpen}
              setModalOpen={setCreateShipmentClose}
              shipmentId={selectedShipmentID}
              onShipmentSuccess={shipmentSuccess}
            />
          </GoogleMapsProvider>
        )}

        <BulkUploadModal
          modalOpen={showBulkUploadModal}
          setModalOpen={setShowBulkUploadModal}
        />
      </div>

      {/* openCreateShipmentDrawer */}
      {openCreateShipmentDrawer && (
        <CommonDrawer
          open={openCreateShipmentDrawer}
          onClose={() => handleCloseDrawer()}
          width={520}
        >
          <CreateShipmentDrawer
            form={form}
            handleCloseDrawer={handleCloseDrawer}
            onSuccess={onCreateShipmentSuccess}
          />
        </CommonDrawer>
      )}
    </>
  );
};

export default Shipments;
